<script>
  import { clientData } from "$lib/client-data/index.svelte.js";
  import { local } from "$lib/client-data/local.js";
  import { onMount } from "svelte";
  import md5 from "md5";
  import Loading from "$lib/components/Loading/Loading.svelte";
  import { beforeNavigate, afterNavigate, goto } from "$app/navigation";
  import { page } from "$app/state";
  import Footer from "$lib/components/Footer/Footer.svelte";
  import { loginData, postLogin, loginAfter } from "../auth/auth.svelte.js";
  import { get } from "$lib/utils/api.js";
  import "virtual:svg-icons-register";
  import { initAppSocket } from "$lib/client-data/layoutSocket.svelte.js";
  import { Toaster } from "$lib/components/Toaster";
  import { getAppMember, getAccountBalance } from "$lib/client-api/my/index.ts";
  import RedRainPacket from "$lib/components/RedPacketRain/RedRainPacket.svelte";
  import { fade } from "svelte/transition";
  let { children, data } = $props();
  const { tenant, isLogin, md5Key, socketUrl, moreButtonData, custom } = data;

  let isLoading = $state(false);
  let loginInfo = local.loginInfo;
  // 客服图标定位物
  let listBoxRef = $state(null);
  let redRainPacketVsibile = $state(false);
  const getMenberInfo = async () => {
    const res = await getAppMember();
    // const res2 = await getAccountBalance();
    if (res.code == 200) {
      local.user.appMember = res.data;
    }
    // if (res2.code == 200) {
    //   local.user.balance = res2.data;
    // }
  };

  beforeNavigate(({ to, delta }) => {
    if (!to) return;
    isLoading = true;
    clientData.isBack = delta == -1 ? 1 : 0;
    // 需要登录才能访问的路径
    // const protectedPaths = ["/sports/list", "/lottery", "/live/streaming", "/sports/push", "/ball/detail", "/my/service"];
    // 如果目标页面需要登录但用户未登录，重定向到登录页
    // if (to && to.url) {
    //   const pathname = to.url.pathname;
    //   const needsAuth = protectedPaths.some((path) => pathname.startsWith(path));

    //   if (needsAuth && !local?.user?.memberId) {
    //     console.log("未登录，重定向到登录页");
    //     goto("/auth/login");
    //   }
    // }
  });

  afterNavigate(({ to, from }) => {
    isLoading = false;

    if (from?.url?.pathname !== local.lastRoute && from?.url?.pathname !== undefined) {
      local.lastRoute = from?.url?.pathname;
    }

    if (!local.hisotryMap) {
      local.hisotryMap = {};
    }
    if (!local.hisotryMap[page.url.pathname]) {
      local.hisotryMap = {
        [page.url.pathname]: window.history.length,
      };
    }
  });

  // 登录
  const sendLogin = async (d) => {
    let _d = { ...d };
    _d.password = md5(md5Key + d.password);
    const res = await postLogin(_d);
    if (res.success) {
      local.user = res.data;
      clientData.auth = local.user;
      await loginAfter(res, _d);
      location.reload();
      if (loginData.openSocket) {
        loginData.openSocket();
      } else {
        initAppSocket({ socketUrl, tenant, isLogin: true, loginData });
      }
    }
  };

  const getVisitorToken = async () => {
    const p = await get("/LIVE-MEMBER/visitor/auth");
    if (p.success) {
      clientData.auth = p.data;
    }
  };

  let layoutHeight = $state("100vh");
  $effect(() => {
    let h = "100vh";
    if (clientData.ShowNavPages.includes(page.route.id) && clientData.footerShow) {
      h = document.body.clientHeight + "px";
    }
    layoutHeight = h;
  });

  onMount(async () => {
    if (!(data.isLogin && local?.user?.memberId)) {
      await getVisitorToken();
    } else {
      clientData.auth = local.user;
    }

    // 初始化 WebSocket 连接
    initAppSocket({ socketUrl, tenant, isLogin, loginData });
    if (loginInfo && typeof loginInfo === "object" && !(isLogin && local?.user?.token)) {
      const d = JSON.parse(JSON.stringify(loginInfo));
      if (d.time + 24 * 60 * 60 * 1000 > Date.now()) {
        sendLogin(d);
      } else {
        // local.loginInfo = null;
      }
    }
    if (isLogin) {
      getMenberInfo();
    }
    let dialogTimer = setTimeout(() => {
      redRainPacketVsibile = true;
    }, 3000);
    return () => {
      clearTimeout(dialogTimer);
    };
  });
</script>

<!-- {#if wsState.status != "connected"}<div class=" flex justify-center text-[10px] items-center gap-2 my-1">连接服务 <progress class="progress w-[64px] h-[4px]"></progress></div>{/if} -->
<div class="w-full h-full max-w-[430px] relative flex flex-col mx-auto">
  <div in:fade out:fade class="flex-1 w-full overflow-x-hidden overflow-y-auto scrollbar-none" style="height: {layoutHeight};" bind:this={listBoxRef} id="app">
    {@render children?.()}
  </div>

  {#if clientData.ShowNavPages.includes(page.route.id) && clientData.footerShow}
    <Footer {moreButtonData} appMember={local?.appMember} {isLogin} {custom}></Footer>
  {/if}
</div>
{#if isLoading}
  <Loading />
{/if}
{#if clientData.toasterShow}
  <Toaster />
{/if}

{#if redRainPacketVsibile}
  <RedRainPacket {tenant} />
{/if}
